'use client';

import { createContext, useContext, type ReactNode, type RefObject } from 'react';

export interface ScrollContainerContextValue {
  containerRef: RefObject<HTMLElement | null> | null;
}

const ScrollContainerContext = createContext<ScrollContainerContextValue>({
  containerRef: null,
});

export function ScrollContainerProvider({
  value,
  children,
}: {
  value: ScrollContainerContextValue;
  children: ReactNode;
}) {
  return (
    <ScrollContainerContext.Provider value={value}>
      {children}
    </ScrollContainerContext.Provider>
  );
}

export function useScrollContainer() {
  return useContext(ScrollContainerContext);
}

export const useScrollContainerContext = useScrollContainer;
